import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';

export interface AfiliasiData {
  keuangan_komisaris: boolean | null;
  keuangan_direksi: boolean | null;
  keuangan_pemegang_saham: boolean | null;
  keluarga_komisaris: boolean | null;
  keluarga_direksi: boolean | null;
  keluarga_pemegang_saham: boolean | null;
  kepengurusan: boolean | null;
}

export interface AfiliasiPerson {
  person_type: string;
  person_id: number;
  name: string;
  position: string;
  afiliasi: AfiliasiData;
}

export interface AfiliasiResponse {
  success: boolean;
  data: AfiliasiPerson[];
}

export function useAfiliasi() {
  const locale = useLocale();
  return useQuery<AfiliasiResponse>({
    queryKey: ['master-afiliasi', locale],
    queryFn: async () => {
      const res = await http.get(`/api/master-afiliasi?locale=${locale}`);
      return res.data;
    },
  });
}
